import { render, staticRenderFns } from "./view-confirm-write-off.vue?vue&type=template&id=0b6df76e&scoped=true&"
import script from "./view-confirm-write-off.vue?vue&type=script&lang=js&"
export * from "./view-confirm-write-off.vue?vue&type=script&lang=js&"
import style0 from "./view-confirm-write-off.vue?vue&type=style&index=0&id=0b6df76e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6df76e",
  null
  
)

export default component.exports